"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _calendarProvider = require("../calendar-provider");

var _SpeakerCard = require("./SpeakerCard.styled");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function LightningTalkCard(_ref) {
  var data = _ref.content.data,
      calendarLinkOptions = _ref.calendarLinkOptions;
  var calendarLink = (0, _calendarProvider.getLightningTalksCalendarLink)(data, calendarLinkOptions);
  var inputId = "input-".concat(data.slug);
  (0, _react.useEffect)(function () {
    document.getElementById(inputId).focus();
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    id: inputId,
    style: {
      height: 0
    },
    tabIndex: "1"
  }), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeaker, {
    id: "popup-".concat(data.slug)
  }, data.lightningTalks && data.lightningTalks.map(function (talk) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: talk.title
    }, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerTop, {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left'
      }
    }, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerAvatarWrap, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerAvatar, {
      src: talk.avatar.url,
      alt: talk.speaker
    })), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerName, null, talk.speaker)), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginBottom: '32px'
      }
    }), /*#__PURE__*/_react.default.createElement(_SpeakerCard.LightningTalkContainer, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerTitle, null, talk.title), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerBio, {
      dangerouslySetInnerHTML: {
        __html: talk.text
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginBottom: '32px'
      }
    })));
  }), calendarLink && /*#__PURE__*/_react.default.createElement(_SpeakerCard.LightningTalkContainer, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopCalendarButton, {
    title: "Add Talk to Calendar",
    href: calendarLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Add Talks to Calendar"))));
}

var _default = LightningTalkCard;
exports.default = _default;